import 'firebase/firestore'
import 'firebase/auth'
import {
	db
} from '../resources/firebase'

/**
 * GET USER
 * @param {*} userID
 */
export function getUser(userID) {
	const userData = new Promise((resolve, reject) => {
		db.collection("users").doc(userID)
			.get()
			.then((doc) => {
				resolve(doc.data())
			})
			.catch((error) => {
				// console.log(error)
				reject(new Error(error))
			})
	})

	return userData
}

//GET USER BY USERNAME
export async function getUserByUsername(username) {
	const userData = new Promise((resolve, reject) => {
		db.collection("users").where("username", "==", username)
			.get()
			.then((snapshot) => {
				if (!snapshot.empty) {
					snapshot.forEach((doc) => {
						resolve(doc.data())
					})
				}
			})
			.catch((error) => {
				// console.log(error)
				reject(new Error(error))
			})
	})

	return userData
}

//GET MULTIPLE USERS
export function getUsers(userIDs) {
	const allUsers = new Promise((resolve, reject) => {
		const userData = []
		userIDs.forEach((userID, index) => {
			db.collection("users").doc(userID)
				.get()
				.then((doc) => {
					userData.push(doc.data())

					if (index === userIDs.length - 1) {
						resolve(userData)
					}
				})
				.catch((error) => {
					// console.log(error)
					reject(new Error(error))
				})
		})
	})

	return allUsers
}



// WEBPACK FOOTER //
// ./src/api/users.js